import CardNumber from "components/card-number/CardNumber";
import { Customer, RankVariant } from "../CustomerList";
import { useDispatch, useSelector } from "react-redux";
import { cardNumberByAddressSelector } from "store/userSliceHelpers";
import { AppDispatch } from "store/store";
import { fetchCardNumber } from "store/cardNumberThunks";
import { useEffect } from "react";

function CustomerItem({
  customer,
  variant,
  unit,
}: {
  customer: Customer;
  variant: RankVariant;
  unit: string;
}) {
  const dispatch = useDispatch<AppDispatch>();
  const cardNumber = useSelector(cardNumberByAddressSelector(customer?.id));

  useEffect(() => {
    if (customer.id && !cardNumber) {
      dispatch(fetchCardNumber(customer.id));
    }
  }, [customer.id, cardNumber, dispatch]);
  return (
    <div key={customer.rank} className="customer-list__item">
      <div className={`customer-list__rank customer-list__rank--${variant}`}>
        {customer.rank}
      </div>
      <div className="customer-list__info">
        <div className="customer-list__id">
          {cardNumber ? (
            <CardNumber value={cardNumber} />
          ) : (
            <span className="value-skeleton" />
          )}
        </div>
        <div className="customer-list__sub">
          {customer.orders} orders · last visit {customer.lastVisit}
        </div>
      </div>
      <div className="customer-list__total">
        {customer.total} {unit}
      </div>
    </div>
  );
}

export default CustomerItem;
